import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40213c3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40213c3a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderType01: require('/var/www/html/jayuvillage/components/headerType01.vue').default,InputRegion: require('/var/www/html/jayuvillage/components/inputRegion.vue').default,ScrollLoading: require('/var/www/html/jayuvillage/components/scrollLoading.vue').default,Navigation: require('/var/www/html/jayuvillage/components/navigation.vue').default})
